import { render } from "./DiagnosticLayout.vue?vue&type=template&id=f113f726&scoped=true"
import script from "./DiagnosticLayout.vue?vue&type=script&lang=js"
export * from "./DiagnosticLayout.vue?vue&type=script&lang=js"

import "./DiagnosticLayout.vue?vue&type=style&index=0&id=f113f726&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f113f726"]])

export default __exports__